// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"307":"e80d1d7d","445":"25abd4a3","490":"2eac6ebc","596":"fdb172fd","790":"c04c8a1f","959":"f97cf721"}[chunkId] + ".chunk.js";
};